export default "__VITE_ASSET__e5eab0f6__"